import "./Footer.scss";

const Footer = () => {
  return (
    <footer>
      <span>&#169; Mihail Marian</span>
      <span className="footer-break"> - </span>
      <span>I have fierce lawyers.</span>
    </footer>
  );
};

export default Footer;
